// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root .v-tabs.tabs-without-arrows .v-tabs-bar{background-color:var(--cp-transparent);outline:none}:root .v-tabs.tabs-without-arrows .v-slide-group__next,:root .v-tabs.tabs-without-arrows .v-slide-group__prev{display:none!important}:root .v-tabs.tabs-without-arrows .v-tab{font-size:1.4rem;margin:0 .8rem;padding:0}:root .v-tabs.tabs-without-arrows .v-slide-group__content{background-color:var(--cp-transparent);margin:0 -.8rem;outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
